export default __webpack_public_path__ + "static/media/selectedMailIcon.529e79dc.png";